<template>
  <div id="adminLogin">
    <vue-particles
      class="login-bg"
      color="#39AFFD"
      :particleOpacity="0.7"
      :particlesNumber="100"
      shapeType="circle"
      :particleSize="4"
      linesColor="#8DD1FE"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    >
    </vue-particles>

    <div class="loginBox">
      <div class="left">
        <h1 class="title">网关配置管理平台</h1>
        <p class="des">助力企业数字化转型，物联网化设备管理</p>
        <p class="des">提供综合监控服务，远程配置服务，采集应用服务</p>
        <div class="img">
          <img
            src="../../assets/login.png"
            width="765"
            height="535"
            alt=""
          >
        </div>
      </div>
      <div class="right">
        <div class="titleBox">
          <span></span>
          <h2>网关远程配置中心后台</h2>
        </div>
        <div class="borderBg">
          <el-form
            :model="loginForm"
            :rules="loginRules"
            ref="loginForm"
            class="loginForm"
            auto-complete="on"
          >
            <el-form-item prop="UserName">
              <el-input
                v-model="loginForm.UserName"
                prefix-icon="el-icon-s-help"
                placeholder="用户名"
              ></el-input>
            </el-form-item>
            <el-form-item prop="Password">
              <el-input
                v-model="loginForm.Password"
                prefix-icon="el-icon-help"
                placeholder="密码"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item prop="Code">
              <div class="codeBox">
                <el-input
                  prefix-icon="el-icon-help"
                  placeholder="验证码"
                  v-model="loginForm.Code"
                  @keyup.enter.native="submitForm('loginForm')"
                >
                  <template slot="suffix">
                    <div
                      class="imgBox"
                      @click="getCode"
                      v-loading="codeLoading"
                    >
                      <el-image
                        style="width:100%;height:100%"
                        :src="`data:image/png;base64,${loginForm.CodeSign}`"
                      >
                        <div
                          slot="error"
                          class="image-slot"
                        >
                          重新加载
                        </div>
                      </el-image>
                    </div>
                  </template>
                </el-input>

              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm('loginForm')"
                style="background-color:#2c86d1;width:100%;border:none"
                :loading="loginLoading"
              >立即登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="content">
      <p> Copyright © www.gz-hoko.com, All Rights Reserved.</p>
      <p>工业和信息化部备案管理系统网站 | 粤ICP备14059767号 | 粤公网安备 44010302000948号</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeLoading: false,
      loginLoading: false,
      loginForm: {
        UserName: "",
        Password: "",
        CodeSign: "",
        Code: "",
      },
      loginRules: {
        UserName: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        PassWord: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        Code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      gatewayData: [],
    };
  },
  mounted() {
    this.getCode();
  },
  methods: {
    async login() {
      this.loginLoading = true;
      let obj = {
        ClientName: "Hoko.Iot.Web.System",
        ClientVersion: "V1.0.0",
        ClientIP: "",
        ...this.loginForm,
      };
      obj.Password = this.$md5(obj.Password);
      const res = await this.$api.axios_http(this.$gd.Login, obj, "POST");
      this.loginLoading = false;

      if (res.ReturnCode == 0) {
        this.$store.commit("user/SET_USERINFO", res.LoginInfo);
        this.$router.push("/admin/index");
      } else {
        this.$message.error(res.Error);
      }
    },
    async getCode() {
      this.codeLoading = true;
      const res = await this.$api.axios_http(this.$gd.GetCode, "", "GET");
      this.codeLoading = false;
      this.loginForm.CodeSign = res;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#adminLogin {
  position: relative;
  height: 100%;
  width: 100%;
  // background-image: linear-gradient(#6baace, #264783);
  background: #00094d;
  display: flex;
  align-items: center;
  justify-content: center;
  .loginBox {
    position: absolute;
    top: 30px;
    width: 80%;
    // background: white;
    padding: 0px 150px;
    display: flex;
    justify-content: left;
    align-items: center;
    // flex-direction: column;
    .left {
      padding-right: 150px;
      color: #f2f2f2;
      .title {
        font-size: 48px;
        font-weight: 600;
      }
      .des {
        font-size: 24px;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      background: #ffffff;
      border: 1px solid #0cda2f;
      border-radius: 5px;
      .borderBg {
        width: 350px;
        height: 100%;
        background-image: url("../../assets/loginBg.png");
        display: flex;
        align-items: center;
        background-size: 100% 100%;
        justify-content: center;
        padding: 40px 0;
      }
    }
    .codeBox {
      display: flex;

      .imgBox {
        margin: 0 10px;
        width: 80px;
        height: 30px;
        cursor: pointer;
        & > div {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .titleBox {
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        width: 6px;
        height: 24px;
        margin-right: 10px;
        border-radius: 20px;
        background-color: #2c86d1;
        top: 2px;
      }
    }
  }
  .content {
    position: absolute;
    bottom: 30px;
    color: #999999;
    font-size: 12px;
    text-align: center;
  }
}
</style>
<style lang="scss">
.login-bg {
  // background: linear-gradient(-180deg, #dcf2e6 0%, #ffffff 100%);
  width: 100%;
  height: 100%; /**宽高100%是为了图片铺满屏幕 */
  position: absolute;
}
.loginBox {
  z-index: 10;
}
#adminLogin {
  .el-input__inner {
    width: 260px;
  }
  .el-input--suffix {
    .el-input__inner {
      padding-right: 110px;
    }
  }
  .el-input__suffix {
    display: flex;
    align-items: center;
  }
}
</style>
